<template>
    <div class="hts-content">
        <TopBar></TopBar>
        <div style="background-color:#f5f5f5;padding: 24px 24px 24px 24px;height: -webkit-fill-available;">
            <div style="background-color: #ffffff;height: -webkit-fill-available;">
            <div class='bread-cls' style="background-color: #f5f5f5;">
                <a-breadcrumb>
                    <a-breadcrumb-item><a href="javascript:void(0)" @click="backToT86">T86</a></a-breadcrumb-item>
                    <a-breadcrumb-item>HTS Check</a-breadcrumb-item>
                </a-breadcrumb>
            </div>
            <div style="margin: 24px 24px 12px 24px; font-size: 16px;font-weight: 600;">{{masterBillNumber}}</div>
            <a-spin :spinning="loadingType">
            <div class='group-check-hts' > 
                <a-checkbox-group v-model:value="checkedHtsStatus" :options="checkStatusOption" name="hts-select" style="gap: 32px;" @change="statusCheckHandle">
                    <template #label="option">
                        <div style="position: relative;top: -4px;"><span>{{ option.label }}</span><span :style="{ color: option.color, 'margin-left': '4px','font-size' : '24px'}">{{ option.num }}</span></div>
                    </template>
                </a-checkbox-group>

            </div>
            <div class='replace_line'>
                
                <div class="replace_btn">
                    <a-button type="primary" @click="replaceByRuleHandle">Replace by rules</a-button>
                </div>
                
                <div class='replace_AI'>
                    <label>Intelligent Replace</label>
                    <a-switch v-model:checked="aiChecked" size="small" :disabled="!hasReplace"/>
                </div>
                
            </div>
            
            <div class='hts-table'>
                <a-table :dataSource="dataSource" :columns="columnsInfo" :pagination="pageData" @change="tableChangeHandle">
                    <template #bodyCell="{ column, record }">
                        <template v-if="column.key === 'PGA Flag'">
                            <div v-if="record.pgaFlags.length > 0">
                                <a-tag v-for="(tag) in record.pgaFlags"
                                
                                :key="tag.title"
                                :color="tag.color"
                                >
                                {{ tag.title }}
                                </a-tag>
                            </div>
                            <div v-else>-</div>
                        </template>
                        <template v-else-if="column.key === 'Description Flag'">
                            <div v-if="record.descriptionFlags.length > 0">
                                <a-tag v-for="(tag) in record.descriptionFlags"
                                
                                :key="tag.title"
                                :color="tag.color"
                                >{{ tag.title }}</a-tag>
                            </div>
                            <div v-else>-</div>
                        </template>
                        <template v-else-if="column.key === 'Valid'">
                            <div v-for="name in record.status" :key="name">
                            
                                <a-badge v-if="name === 'Invalid'" color="red" />
                                <a-badge v-else-if="name === 'HTS Warning'" color="orange" />
                                <a-badge v-else-if="name === 'Description Warning'" color="yellow" />
                                <a-badge v-else color="green" />
                                <label>{{ name }}</label>
                            </div>
                        </template>
                        <template v-else-if="column.key === 'actions'">
                            <div v-if="aiChecked">
                                <a href="javascript:void(0)" @click="getRecommond(record)" >Edit</a>
                               
                                <a-divider v-if="record.descriptionFlags.length > 0" type="vertical"></a-divider>
                                <a href="javascript:void(0)" v-if="record.descriptionFlags.length > 0" @click="believeHandle(record)">Skip</a>
                              
                            </div>
                            <div v-else>-</div>
                        </template>
                        <template v-else-if="column.key === 'HTS Description'">
                            <a-tooltip trigger="click" placement="topLeft">
                                <template #title>{{ record.htsDescription }}</template>
                                <div class="hts-description-detail">{{ record.htsDescription }}</div>
                            </a-tooltip>
                        </template>
                    </template>
                </a-table>
            </div>
            </a-spin>
            <div class="hts-drawer">
                
                <a-drawer 
                width=750 
                title="Edit"
                :closable=true
                :maskClosable = false
                :open="drawerShow"
                :destroyOnClose= true
                @close="onClose"
                >
                    <template #extra>
                        <div style="display: flex;">
                            <div style="flex:1;"></div>
                            <div style="display: flex;gap: 8px;">
                                <!-- <a-button :loading="saveLoading" @click="onClose">Cancel</a-button> -->
                                <a-button :loading="saveLoading" @click="saveHandle(false)">Save</a-button>
                                <a-button :loading="saveLoading" type="primary" @click="saveHandle(true)">Submit And Save Rules</a-button>
                            </div>
                        </div>
                    </template>
                    <a-spin :spinning="saveLoading" style="z-index: 1050;">
                    <a-drawer v-model:open="ruleDrawer" 
                        width=500
                        :maskClosable=false
                        title="Choose Save Rules"
                        :closable=true
                    >
                        <template #extra>
                            <div style="display: flex;">
                            <div style="flex:1;"></div>
                            <div style="display: flex;gap: 8px;">
                                <!-- <a-button @click="ruleDrawer = false">Cancel</a-button> -->
                                <a-button :loading="saveLoading" type="primary" @click="saveAndRuleHandle">Submit</a-button>
                            </div>
                        </div>
                        </template>
                        <div v-for="rule in ruleData " :key="rule.saveRule" style="margin-bottom: 24px;">
                            <div>
                                <a-radio :checked="selectRule.saveRule === rule.saveRule"  :value="rule.saveRule" @change="onRuleRadioChange(rule)"></a-radio>
                                <label class="rule-label" v-if="rule.saveRule===1">Replace HTS Code</label>
                                <label class="rule-label" v-else-if="rule.saveRule === 2">Replace Description</label>
                                <label class="rule-label" v-else-if="rule.saveRule === 3 && rule.newDescription == rule.originalDescription">Replace HTS Code Where Description</label>
                                <label class="rule-label" v-else-if="rule.saveRule === 3 && rule.newHtsCode == rule.originalHtsCode">Replace Description Where HTS Code</label>
                                <label class="rule-label" v-else-if="rule.saveRule ===3 && rule.newHtsCode != rule.originalHtsCode && rule.newDescription != rule.originalDescription">Replace HTS Code And Description</label>
                            </div>
                            <div v-if="rule.saveRule === 1" class="rule-info-detail">
                                <a-descriptions
                                layout="vertical"
                                size="small"
                                :labelStyle="{'color': '#000000A6', 'font-weight' : 400, height: '14px'}"
                                :contentStyle="{ 'display': '-webkit-box', 'font-weight' : 400,'WebkitBoxOrient': 'vertical', 'WebkitLineClamp': 2, 'overflow': 'hidden', 'textOverflow': 'ellipsis' }"
                                :column="{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }"
                                >
                                    <a-descriptions-item label="HTS Code">{{ rule.originalHtsCode }}</a-descriptions-item>
                                    <a-descriptions-item label="New HTS Code">{{ rule.newHtsCode }}</a-descriptions-item>
                                </a-descriptions>
                            </div>
                            <div v-if="rule.saveRule === 2" class="rule-info-detail">
                                <a-descriptions
                                layout="vertical"
                                size="small"
                                :labelStyle="{'color': '#000000A6', 'font-weight' : 400}"
                                :contentStyle="{ 'display': '-webkit-box', 'font-weight' : 400,'WebkitBoxOrient': 'vertical', 'WebkitLineClamp': 2, 'overflow': 'hidden', 'textOverflow': 'ellipsis' }"
                                :column="{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }"
                                >
                                    <a-descriptions-item label="Shipment Description" :span="2">{{ rule.originalDescription }}</a-descriptions-item>
                                    <a-descriptions-item label="New Shipment Description" :span="2">{{ rule.newDescription }}</a-descriptions-item>
                                </a-descriptions>
                            </div>
                            <div v-if="rule.saveRule === 3" class="rule-info-detail">
                                <a-descriptions
                                layout="vertical"
                                size="small"
                                :labelStyle="{'color': '#000000A6', 'font-weight' : 400}"
                                :contentStyle="{ 'display': '-webkit-box', 'font-weight' : 400,'WebkitBoxOrient': 'vertical', 'WebkitLineClamp': 2, 'overflow': 'hidden', 'textOverflow': 'ellipsis' }"
                                :column="{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }"
                                >
                                    <a-descriptions-item label="HTS Code">{{ rule.originalHtsCode }}</a-descriptions-item>
                                    <a-descriptions-item v-if="rule.originalHtsCode !== rule.newHtsCode" label="New HTS Code">{{ rule.newHtsCode }}</a-descriptions-item>
                                    <a-descriptions-item label="Shipment Description" :span="2">{{ rule.originalDescription }}</a-descriptions-item>
                                    <a-descriptions-item v-if="rule.originalDescription !== rule.newDescription" label="New Shipment Description" :span="2">{{ rule.newDescription }}</a-descriptions-item>
                                </a-descriptions>
                            </div>
                        </div>
                        
                    </a-drawer>
                    <a-descriptions 
                    :dataSource="itemData" 
                    layout="vertical"
                    size="small"
                    :labelStyle="{'color': '#000000A6', 'font-weight' : 400, height: '14px'}"
                    :contentStyle="{ 'display': '-webkit-box', 'font-weight' : 400,'WebkitBoxOrient': 'vertical', 'WebkitLineClamp': 2, 'overflow': 'hidden', 'textOverflow': 'ellipsis' }"
                    :column="{ xxl: 3, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }"
                    >
                        <template #title>
                            <div style="display: flex; height: 32px; align-items: center;"><img src='../assets/image/info.png' style="width: 32px; height: 32px; " /> <label style="margin-left: 8px; font-size: 16px; font-weight: 500;line-height: 22px;">Original Infomation</label></div>
                        </template>
                        <a-descriptions-item label="HTS Code">{{ itemData.htsCode }}</a-descriptions-item>
                        <a-descriptions-item label="HTS Description">
                            <a-tooltip trigger="click" placement="topLeft">
                                    <template #title>{{ itemData.htsDescription }}</template>
                                    <div class="hts-description-detail">{{ itemData.htsDescription }}</div>
                            </a-tooltip>

                        </a-descriptions-item>
                        <a-descriptions-item label="PGA">
                            <div v-if="itemData.pgaFlags.length > 0">
                                <a-tag v-for="(tag) in itemData.pgaFlags"
                                
                                :key="tag.title"
                                :color="tag.color"
                                >
                                {{ tag.title }}
                                </a-tag>
                            </div>
                            <div v-else>-</div>
                        </a-descriptions-item>
                    </a-descriptions>
                    <a-descriptions
                    :dataSource="itemData" 
                    layout="vertical"
                    size="small"
                    style="margin-top: 8px;"
                    :labelStyle="{'color': '#000000A6', 'font-weight' : 400, height: '14px'}"
                    :contentStyle="{ 'display': '-webkit-box', 'font-weight' : 400,'WebkitBoxOrient': 'vertical', 'WebkitLineClamp': 2, 'overflow': 'hidden', 'textOverflow': 'ellipsis' }"
                    :column="{ xxl: 3, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }"
                    >
                        <a-descriptions-item label="Shipment Description">{{ itemData.nameEn }}</a-descriptions-item>
                        <a-descriptions-item label="Shipment Link">
                            <div>
                                <div v-for="(urlInfo) in itemData.urls" :key="urlInfo.productId" style="background-color: #F1F4FF;display: inline-block;padding-left:4px; padding-right:4px;border-radius: 4px;">
                                    <!-- <a :href="urlInfo.productUrl" target="_blank" style="display: inline-block;">{{ urlInfo.nameCn }} <LinkOutlined /></a> -->
                                    <div @click="openLink(urlInfo.productUrl,)" class="ship-link">{{ urlInfo.nameCn }} <LinkOutlined /></div>
                                </div>
                            </div>
                        </a-descriptions-item>
                        <a-descriptions-item label=" Description Flag">
                            <div v-if="itemData.descriptionFlags.length > 0">
                                <a-tag v-for="(tag) in itemData.descriptionFlags"
                                :key="tag.title"
                                :color="tag.color"
                                >{{ tag.title }}</a-tag>
                            </div>
                            <div v-else>-</div>
                    </a-descriptions-item>
                        
                    </a-descriptions>
                    <div class="dashed-line"></div>
                    <div>
                        <div style="display: flex; height: 32px; align-items: center;"><img src='../assets/image/desc.png' style="width: 32px; height: 32px; " /> <label style="margin-left: 8px; font-size: 16px; font-weight: 500;line-height: 22px;">NEW Shipment Description</label></div>
                        <div style="margin-top: 8px;">
                            
                            <div v-if="!isEditing" class="text-edit-field" @mouseenter="showEditButton = true" @mouseleave="showEditButton = false" >
                                <label>{{ newNameEn }} </label>
                                <img v-if="showEditButton" src="../assets/image/edit.png" @click="isEditing=true"/>
                            </div>
                            <a-input v-else  v-model:value="newNameEn" @pressEnter="isEditing = false">
                                <template #suffix>
                                    <img src='../assets/image/ok.png' style="width: 20px;height: 20px;" @click="isEditing = false" />
                                </template>
                            </a-input>
                        </div>
                        
                    </div>
                    <div class="dashed-line"></div>
                    <div v-if="itemData.pgaFlags.length > 0">
                        <a-spin :spinning="loadingSuggest">
                        <div class="suggest-hts">
                            <a-checkbox v-model:checked="isRecommend" @change="recommendChangeHandle">Recommended HTS Selection</a-checkbox>
                        </div>
                        <div v-if="isRecommend" class="hts-modal-table" style="margin-top:24px ;">
                            <a-spin :spinning="isLoadingRecommend">
                                <a-segmented v-model:value="recommendType" :options="recommendTypes" />
                                <div class="hts-modal-content" style="margin-top:16px ;">
                                    <a-table v-if="recommendType === 'RTIS'" :dataSource="recommendData" :columns="recommendColumn" :pagination="false" size='small'>
                                        <template #bodyCell="{ column, record }">
                                            <template v-if="column.key === 'radio'">
                                                <a-radio :checked="selectInfo.selectIndex === record.index" :value="record.index" @change="onRadioChange(record)"></a-radio>
                                            </template>
                                            <template v-if="column.key === 'confidenceLevel'">
                                                <a-progress :percent="Math.floor(record.confidenceLevel * 100)" size="small" :strokeColor="'#000000'"/>
                                            </template>
                                            <template v-if="column.key === 'pgaFlags'">
                                                <div v-if="record.pgaFlags?.length > 0">
                                                    <a-tag v-for="(tag) in record.pgaFlags"
                                                    :key="tag.title"
                                                    :color="tag.color"
                                                    >
                                                    {{ tag.title }}
                                                    </a-tag>
                                                </div>
                                                <div v-else>-</div>
                                            </template>
                                            <template v-if="column.key === 'htsDescription'">
                                                <a-tooltip trigger="click" placement="topLeft">
                                                    <template #title>{{ record.htsDescription }}</template>
                                                    <div class="hts-description-detail">{{ record.htsDescription }}</div>
                                                </a-tooltip>
                                            </template>
                                        </template>
                                    </a-table>
                                    <a-form v-else layout="vertical" 
                                    :model="htsFormData"
                                    >
                                        <a-form-item label="New HTS">
                                            <a-input v-model:value="htsFormData.htsCode" @pressEnter="getHtsInfo" >
                                                <template #suffix>
                                                    <img src='../assets/image/ok.png' style="width: 20px;height: 20px;" @click="getHtsInfo"/>
                                                </template>
                                            </a-input>
                                        </a-form-item>
                                        <a-form-item label="New HTS Description" :bordered="false">
                                            <a-textarea v-model:value="htsFormData.htsDesc" :row="3" readonly/>
                                        </a-form-item>
                                        <a-form-item label="PGA">
                                            <div v-if="htsFormData.pgaFlags.length > 0">
                                                <a-tag v-for="(tag) in htsFormData.pgaFlags"
                                
                                                :key="tag.title"
                                                :color="tag.color"
                                                >
                                                {{ tag.title }}
                                                </a-tag>
                                            </div>
                                            <div v-else>-</div>
                                        </a-form-item>
                                        
                                    </a-form>
                                </div>
                            </a-spin>
                        </div>
                        </a-spin>
                    </div>
                    <div v-else>
                        <div style="display: flex; height: 32px; align-items: center;"><img src='../assets/image/hts.png' style="width: 32px; height: 32px; " /> <label style="margin-left: 8px; font-size: 16px; font-weight: 500;line-height: 22px;">Replace HTS Code</label></div>
                        <div class="hts-form" style="margin-top: 24px;">
                            <a-form layout="vertical" :model="htsFormData">
                                <a-form-item label="New HTS">
                                    <a-input v-model:value="htsFormData.htsCode" @pressEnter="getHtsInfo">
                                    <template #suffix>
                                        <img v-if="htsFormData.htsCode != ''" src='../assets/image/ok.png' style="width: 20px;height: 20px;" @click="getHtsInfo" />
                                    </template>
                                    </a-input>
                                </a-form-item>
                                <a-form-item label="New HTS Description">
                                    
                                    <a-textarea v-model:value="htsFormData.htsDesc" :row="3" disabled readonly/>
                                    
                                </a-form-item>
                                <a-form-item label="PGA">
                                    <div v-if="htsFormData.pgaFlags.length > 0">
                                        <a-tag v-for="(tag) in htsFormData.pgaFlags"
                        
                                        :key="tag.title"
                                        :color="tag.color"
                                        >
                                        {{ tag.title }}
                                        </a-tag>
                                    </div>
                                    <div v-else>-</div>
                                </a-form-item>
                            </a-form>
                        </div>
                    </div>
                    </a-spin>
                </a-drawer>
                
            </div>
        </div>
        </div>
    </div>
</template>

<script lang="ts">

import { defineComponent, onMounted, ref, nextTick, reactive} from 'vue'
import { LinkOutlined } from "@ant-design/icons-vue"
import { useRoute } from 'vue-router'
import Api from '../api/Api'
import TopBar from '@/components/TopBar.vue'
import pgaData from '@/pga-data.json'
import router from "@/router"
import { setCache, getCache } from "@/common/storage"
import { message } from 'ant-design-vue'

export default defineComponent({
    name : 't86info',
    components:{
        TopBar,
        LinkOutlined
    },
    setup() {
        const route = useRoute()
        
        const mainId  = route.query.mainId
        const masterBillNumber = route.query.masterBillNumber

        const hasReplace = ref(false)
        let replaceHistory = getCache('replaceHistory')
        if( !replaceHistory){
            replaceHistory = []
            setCache('replaceHistory', replaceHistory)
        }
        if( replaceHistory.indexOf(masterBillNumber) >= 0){
            hasReplace.value = true
        }

        const loadingType = ref(false)

        const itemData = ref()
        const loadingSuggest = ref(false)
        const saveLoading = ref(false)
        const drawerShow = ref(false)
        
        const newNameEn = ref<string>("")
        const isDescWarning = ref(false)
        const showEditButton = ref(false)
        const isEditing = ref(false)
        const isRecommend = ref(false)

        const recommendTypes = reactive(['RTIS', 'Replace HTS Code'])
        const recommendType = ref(recommendTypes[0])
        const recommendData: any = ref([])

        const selectInfo = reactive({
            'selectIndex' : '',
            'selectItem' : ''
        })

        const recommendColumn = [
            {key : 'radio', width: '50px', align : 'center'},
            {title:'New HTS Code', dataIndex:'htsCode', key:'htsCode', width : '120px'},
            {title:'New HTS Description', dataIndex:'htsDescription', key:'htsDescription',ellipsis: {showTitle: false}},
            {title:'PGA', dataIndex:'pgaFlags', key:'pgaFlags',width : '120px'},
            {title:'Matching', dataIndex:'confidenceLevel', key:'confidenceLevel', width : '100px'},
        ]
        
        interface RuleData {
            saveRule : number,
            originalHtsCode : string,
            newHtsCode : string,
            originalDescription : string,
            newDescription : string,
        }
        
        interface PgaData {
            title : any,
            color : string
        }
        interface HTSData {
            htsCode : string,
            htsDesc : string,
            pgaFlags: PgaData[],
            isValid : boolean
        }
        
        const htsFormData = reactive<HTSData>({
            htsCode : '',
            htsDesc : '',
            pgaFlags: [],
            isValid : false
        })

        const isLoadingRecommend = ref(false)
        const ruleDrawer = ref(false)
        const ruleData = ref<RuleData[]>([])
        const selectRule = reactive<RuleData>({
            saveRule: 0,
            originalDescription : '',
            originalHtsCode : '',
            newDescription : '',
            newHtsCode : ''
        })

        const aiChecked = ref(false)
        const checkedHtsStatus = ref(['Invalid', 'HTS Warning','Description Warning'])
        const pageData = ref({
            current : 1,
            pageSize : 10,
            total: 0,
            showSizeChanger: false,
            showQuickJumper: false,
            showLessItems : true,
        })

        const dataSource : any = ref([])
        const columnsInfo : any = ref([
            {title:'Valid', dataIndex:'status', key:'Valid', width : 200},
            {title: 'HTS', dataIndex : 'htsCode', key: 'HTS', width : 200},
            {title: 'Shipment Description', dataIndex: 'nameEn', key: 'Shipment Description',ellipsis: true},
            {title: 'Description Flag', dataIndex: 'descriptionFlags', key: 'Description Flag', width: 200},
            {title:'PGA Flag', dataIndex:'pgaFlags', key:'PGA Flag', width: 200},
            {title:'HTS Description', dataIndex:'htsDescription', key:'HTS Description', ellipsis: {showTitle: false,}},
            {title:'Action',  key:'actions', width: 200},            
        ])

        onMounted(() =>{
            nextTick(async()=>{
                showLoading(true)
                await getSummary(mainId)
                await getData(mainId)
                showLoading(false)
            })
        })
        
        const checkStatusOption = ref([
            { label: 'Valid', value: 'Valid', "num" : 0 , 'color' : '#52C41A'},
            { label: 'HTS Warning', value: 'HTS Warning', "num" : 0 , 'color' : '#FA8C16'},
            { label: 'Shipment Description Warning', value: 'Description Warning', "num" : 0 ,'color' : '#FADB14'},
            { label: 'InValid', value: 'Invalid',"num" : 0, 'color' : '#F5222D'},
        ])

        const getSummary = async(mainId : any) =>{
            let data = await Api.getReviewSummary(mainId)
            if( data && data?.code === 200){
                let response_data = data.data
                if( response_data){
                    response_data.forEach(value =>{
                        if( value.status === 'Valid'){
                            checkStatusOption.value[0].num = value.count
                        }else if(value.status === 'HTS Warning'){
                            checkStatusOption.value[1].num = value.count
                        }else if( value.status === 'Description Warning'){
                            checkStatusOption.value[2].num = value.count
                        }else if( value.status === 'Invalid'){
                            checkStatusOption.value[3].num = value.count
                        }
                    })
                }
            }else {
                if(data && data?.code === 401){
                    setCache('userInfo', '')
                    setCache('jwt', '')
                    router.push({path: '/login'})
                    return
                }
            }

        }
        const getData = async(mainId : any)=>{
            if( mainId == undefined || mainId == null){
                return
            }
            let params = {
                pageSize : pageData.value.pageSize,
                pageNum : pageData.value.current,
                statusList : checkedHtsStatus.value
            }
            showLoading(true)
            let data = await Api.getHtsById(mainId, params)
            if( !data || !data.code || data.code !== 200){
                showLoading(false)
                if( data && data?.code === 401){
                    return;
                }
                message.error('Get Data Fail', 2)
                return
            }
            showLoading(false)
            dataSource.value = []
            if( data.total > 0 ){
                pageData.value.total = data.total
            }
        
            for( let i = 0 ; i< data.rows.length; i++){
                
                data.rows[i].index = i +1;
                if( data.rows[i].pgaFlags && data.rows[i].pgaFlags.length> 0){
                    for( let k = 0; k < data.rows[i].pgaFlags.length; k++ ){
                        let obj = {
                            title : data.rows[i].pgaFlags[k],
                            color : getPgaFlagData(data.rows[i].pgaFlags[k])
                        }
                        data.rows[i].pgaFlags[k] = obj
                    }
                }
                data.rows[i]['descriptionFlags'] = []
                if( data.rows[i]['isBlurry'] === 1 ){
                    data.rows[i]['descriptionFlags'].push({
                        title : "Vague",
                        color : 'red'
                    })
                }
                if( data.rows[i]['isMatched'] !== 1 ){
                    data.rows[i]['descriptionFlags'].push({
                        title : "MisMatch",
                        color : 'red'
                    })
                }
                dataSource.value.push(data.rows[i])
            }
            return
        }

        const tableChangeHandle = async(pagination : any) =>{
            
            if( pageData.value.current == pagination.current && pageData.value.pageSize == pagination.pageSize){
                return
            }else{
                
                pageData.value.current = pagination.current
                pageData.value.pageSize = pagination.pageSize
                getData(mainId)
            }
        }

        const getRecommond = async(item : any ) =>{
            console.log("ddddd",item)
            item.urls = []
            if( item.extraInformation){
                console.log(typeof item.extraInformation)
                if( typeof item.extraInformation === 'object'){
                    if( Array.isArray(item.extraInformation)){
                        for( let i = 0; i < item.extraInformation?.length; i++){
                            item.urls.push(item.extraInformation[i])
                        }
                    }else{
                        item.urls.push(item.extraInformation)
                    }
                }
            }
            console.log('urls', item.urls)
            drawerShow.value= true
            itemData.value = item
            newNameEn.value = item.nameEn
            if( item.descriptionFlags.length > 0) {
                isEditing.value = true
                showEditButton.value = false
            }else{
                isEditing.value = false
                showEditButton.value = false
            }
        }

        const getPgaFlagData = ( flag : string ) =>{
            for( let i = 0; i < pgaData.length; i++){
                if( pgaData[i]['tariffFlagCode'] == flag ){
                    if(pgaData[i]['agencyCodeType'] === "M"){
                        return "warning"
                    }else if(pgaData[i]['agencyCodeType'] === "R" ){
                        return "error"
                    }
                }
            }
            return "yellow"
        }
        const onClose = ()=>{
            recommendData.value = []
            recommendType.value = recommendTypes[0]

            ruleDrawer.value = false
            htsFormData.htsCode = ''
            htsFormData.htsDesc = ''
            htsFormData.pgaFlags = []
            htsFormData.isValid = false

            selectInfo.selectIndex = ''
            selectInfo.selectItem = ''

            selectRule.saveRule =  0
            selectRule.originalDescription = ''
            selectRule.originalHtsCode = ''
            selectRule.newDescription = ''
            selectRule.newHtsCode =''
        

            loadingSuggest.value = false
            saveLoading.value = false
            drawerShow.value = false

            newNameEn.value = ""
            isDescWarning.value = false
            showEditButton.value = false
            isEditing.value = false
            isRecommend.value = false
            isLoadingRecommend.value = false

        }

        const recommendChangeHandle = async(e: any) =>{
            if( isRecommend.value == true){
                loadingSuggest.value = true
                
                recommendData.value = []
                let params = {
                    htsCode : itemData.value.htsCode,
                    description : itemData.value.nameEn
                }
                let data = await Api.getHtsRecommond(params)
                loadingSuggest.value = false
                if( data && data.code && data.code  === 200){
                    if( data.data && data.data.suggestList){
                        data.data.suggestList.sort((a, b) => b.confidenceLevel - a.confidenceLevel)
                        for(let i = 0; i < data.data.suggestList.length; i++){
                            data.data.suggestList[i].index = i+1
                            let hts_code : string  = data.data.suggestList[i].htsCode
                            hts_code = hts_code.replace(/\./g, '')
                            if( hts_code === itemData.value.htsCode){
                                console.log('error self suggest')
                                continue
                            }
                            data.data.suggestList[i].htsCode = hts_code
                            if( data.data.suggestList[i].pgaFlags){
                                if( data.data.suggestList[i].pgaFlags?.length > 0){
                                    let newPgaflags = []
                                    for( let k = 0; k <data.data.suggestList[k].pgaFlags?.length; k++){
                                        let obj = {
                                            title : data.data.suggestList[i].pgaFlags[k],
                                            color : getPgaFlagData(data.data.suggestList[i].pgaFlags[k])
                                        }
                                        console.log('push obj',obj)
                                        newPgaflags.push(obj)
                                    }
                                    data.data.suggestList[i].pgaFlags = newPgaflags
                                }
                                
                            }
                            
                            recommendData.value.push(data.data.suggestList[i])
                        }
                        console.log('recommend data', recommendData.value)
                    }
                }else{
                    message.error("Get Suggest Error", 2)
                }
                
            }

        }

        const replaceByRuleHandle = async() =>{
            if( mainId ){
                showLoading(true)
                let response_data = await Api.replaceByRule(mainId)
                if( response_data &&response_data?.code === 200 ){
                    await getSummary(mainId)
                    pageData.value.current = 1
                    await getData(mainId)
                    message.success("Replace Succ",2)
                    hasReplace.value = true
                    let replaceHistory = getCache('replaceHistory')
                    if( replaceHistory.indexOf(masterBillNumber) < 0 ){
                        replaceHistory.push(masterBillNumber)
                        setCache('replaceHistory', replaceHistory)
                    }
                    showLoading(false)
                }else{
                    showLoading(false)
                    message.error("Network Error", 2)
                }
                
            }
        }

        const believeHandle = async(item : any) =>{
            let params = {
                description : item.nameEn,
                reason : 'no reason'
            }
            showLoading(true)
            let data = await Api.ineffectiveVague(params)
            if( data && data.code && data.code === 200){
                await getSummary(mainId)
                pageData.value.current = 1
                await getData(mainId)
                message.success("Skip Succ",2)
                showLoading(false)
            }else{ 
                showLoading(false)
                message.error("Skip Fail", 2)

            }
        }

        const statusCheckHandle = (checkedValue : any) =>{
           
            pageData.value.current = 1
            getData(mainId)
        }

        const showLoading = (status : boolean ) =>{
            loadingType.value = status
        }

        const onRadioChange = (item: any)=>{
            selectInfo.selectIndex = item.index
            selectInfo.selectItem = item.htsCode
        }

        const saveAndRuleHandle = async()=>{
            if(selectRule.saveRule === 0){
                message.error("Please select a rule", 2)
                return
            }
            if( !masterBillNumber ){
                message.error('Data Error', 2)
                return
            }
            saveLoading.value = true
            showLoading(true)
            let response_data = await Api.updateData(masterBillNumber, selectRule)
            if( response_data && response_data?.code === 200){
                message.success("Succ",1)
                onClose()
                showLoading(true)
                await replaceByRuleHandle()
                // await getSummary(mainId)
                // await getData(mainId)
                showLoading(false)
            }else{
                message.error('Save Fail', 1)
                saveLoading.value = false
                showLoading(false)

            }
        }

        const saveHandle = async( isRule : boolean) =>{

            interface saveParams {
                originalHtsCode : string,
                newHtsCode : string,
                originalDescription: string,
                newDescription : string,
                saveRule : number
            }
            let params : saveParams = {
                originalHtsCode : '',
                newHtsCode : '',
                originalDescription: '',
                newDescription : '',
                saveRule : 0
            }
            params.saveRule = 0
            params.originalDescription = itemData.value.nameEn
            params.originalHtsCode = itemData.value.htsCode
            
            params.newDescription = newNameEn.value

            if( isRecommend.value === true && recommendType.value === 'RTIS'){
                if( !selectInfo.selectItem){
                    message.error("Please select new Hts",1)
                }else{
                    params.newHtsCode = selectInfo.selectItem
                }
            }else{
                if( htsFormData.isValid == false && htsFormData.htsCode != ''){
                    message.error('Please enter the valid htscode')
                    return
                }
                if( htsFormData.htsCode != "" ){
                    params.newHtsCode = htsFormData.htsCode
                }else{
                    params.newHtsCode = itemData.value.htsCode
                }
            }
            
            if( params.newDescription === params.originalDescription && params.newHtsCode === params.originalHtsCode){
                message.error("Please fill in your modifications")
                return
            }
            if( isRule ){
                
                ruleData.value = []
                if( params.newDescription == params.originalDescription){   //只有税号的修改
                    let obj : RuleData = {
                        originalDescription : params.originalDescription,
                        newDescription : params.newDescription,
                        originalHtsCode : params.originalHtsCode,
                        newHtsCode : params.newHtsCode,
                        saveRule : 1
                    }
                    ruleData.value.push(obj)
                    let obj4 : RuleData = {
                        originalDescription : params.originalDescription,
                        newDescription : params.newDescription,
                        originalHtsCode : params.originalHtsCode,
                        newHtsCode : params.newHtsCode,
                        saveRule : 3
                    }
                    ruleData.value.push(obj4)
                    
                    ruleDrawer.value = true

                    return
                }

                if( params.newHtsCode == params.originalHtsCode){    //只修改了描述
                    
                    let obj : RuleData = {
                        originalDescription : params.originalDescription,
                        newDescription : params.newDescription,
                        originalHtsCode : params.originalHtsCode,
                        newHtsCode : params.newHtsCode,
                        saveRule : 2
                    }
                    ruleData.value.push(obj)
                    let obj4 : RuleData = {
                        originalDescription : params.originalDescription,
                        newDescription : params.newDescription,
                        originalHtsCode : params.originalHtsCode,
                        newHtsCode : params.newHtsCode,
                        saveRule : 3
                    }
                    ruleData.value.push(obj4)

                    ruleDrawer.value = true
                    return
                }
                
                    let obj : RuleData = {
                        originalDescription : params.originalDescription,
                        newDescription : params.newDescription,
                        originalHtsCode : params.originalHtsCode,
                        newHtsCode : params.newHtsCode,
                        saveRule : 1
                    }
                    ruleData.value.push(obj)
                    let obj4 : RuleData = {
                        originalDescription : params.originalDescription,
                        newDescription : params.newDescription,
                        originalHtsCode : params.originalHtsCode,
                        newHtsCode : params.newHtsCode,
                        saveRule : 2
                    }
                    ruleData.value.push(obj4)
                    let obj5 : RuleData = {
                        originalDescription : params.originalDescription,
                        newDescription : params.newDescription,
                        originalHtsCode : params.originalHtsCode,
                        newHtsCode : params.newHtsCode,
                        saveRule : 3
                    }
                    ruleData.value.push(obj5)

                    ruleDrawer.value = true

                return
            }
            saveLoading.value = true
            
            let response = await Api.updateData(masterBillNumber, params)
            
            if( response && response?.code === 200){
                saveLoading.value = false
                message.success('Succ',2)
                onClose()
                showLoading(true)
                await getSummary(mainId)
                await getData(mainId)
                showLoading(false)
            }else{
                message.error("Save Fail", 2)
                saveLoading.value = false
            }
            
        }
        
        const getHtsInfo = async() =>{
            console.log("get hts", htsFormData.htsCode)
            if( htsFormData.htsCode != "" ){
                let regex = /^\d{7,}$/
                htsFormData.htsDesc = 'Loading'
                htsFormData.pgaFlags = []
                htsFormData.isValid = false
                if( regex.test(htsFormData.htsCode) === false){
                    htsFormData.htsCode= ''
                    htsFormData.htsDesc = "Please input valid hts code"
                    return
                }
                let data = await Api.getHtsInfo(htsFormData.htsCode)
                console.log(data)
                if( data.code && data.code === 200){
                    htsFormData.htsDesc = data.data.description
                    htsFormData.pgaFlags = []
                    
                    for( let i = 0; i < data.data.pgaFlags.length; i++){
                        let obj = {
                            title : data.data.pgaFlags[i],
                            color : getPgaFlagData(data.data.pgaFlags[i])
                        }
                        htsFormData.pgaFlags.push(obj)
                    }
                    htsFormData.isValid = true
                }else{
                    htsFormData.isValid = false
                    htsFormData.htsDesc = 'The htsCode is invalid'
                }
                
            }
        }

        const codeChangeHandle = (e)=>{
            console.log("0000change",e)

        }

        const onRuleRadioChange = (rule: RuleData) =>{
            selectRule.saveRule = rule.saveRule
            selectRule.newDescription = rule.newDescription
            selectRule.newHtsCode = rule.newHtsCode
            selectRule.originalDescription = rule.originalDescription
            selectRule.originalHtsCode = rule.originalHtsCode
        }

        const backToT86 = ()=>{
            router.push({
                name: 'clearance',
                query: {
                    type : '2'
                }
            })
        }
        const openLink = ( url : string ) =>{
            window.open(url, '_blank')
        }

        return {
            checkedHtsStatus,
            checkStatusOption,
            aiChecked,
            hasReplace,
            dataSource,
            columnsInfo,
            pageData,
            tableChangeHandle,
            getRecommond,
            drawerShow,
            itemData,
            newNameEn,
            onClose,
            isDescWarning,
            showEditButton,
            isEditing,
            isRecommend,
            recommendTypes,
            recommendType,
            recommendColumn,
            recommendData,
            htsFormData,
            recommendChangeHandle,
            isLoadingRecommend,
            replaceByRuleHandle,
            believeHandle,
            statusCheckHandle,
            masterBillNumber,
            loadingType,
            loadingSuggest,
            selectInfo,
            onRadioChange,
            saveHandle,
            getHtsInfo,
            codeChangeHandle,
            backToT86,
            ruleDrawer,
            ruleData,
            selectRule,
            onRuleRadioChange,
            saveAndRuleHandle,
            openLink,
            saveLoading
        }
    },
})
</script>
<style scoped>
.hts-content{
    width: 100%;
    height: 100vh;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    background: #F5F5F5;
}

.bread-cls{
    padding-bottom: 16px;
}

.group-check-hts {
    margin-left: 24px;
    margin-top: 12px;
}
.replace_line {
    display: flex;
    height: 32px;
    margin-top: 16px;
    margin-left: 24px;
    margin-right: 24px;
}

.replace_btn {
    flex :1;
}
.replace_AI{
    display: flex;
    align-items: center;
    width : 154px;
    font-size: 14px;
    font-weight: 400;
    gap:8px;
    color: rgba(0,0,0,0.85);
}
.hts-table{
    margin: 24px;
}

.text-edit-field {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px; 
    
    width: 100%;
}
.text-edit-field:hover{
    background-color: #F1F4FF;
}

.text-edit-field label {
    flex: 1;
    margin-left: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.text-edit-field img {
    margin-left: 8px;
}
.dashed-line {
  border: 1px dashed rgba(0, 0, 0, 0.09); 
  height: 0; 
  margin-top:12px;
  margin-bottom: 24px;
}
.rule-info-detail {
    background-color: #f5f5f5;
    margin-left: 24px;
    padding: 12px;
    margin-top: 8px;
    border-radius: 4px;
}
.rule-label{
    font-size: 16px;
    font-weight: 500;
}
.ship-link {
    color: #595959;
    cursor: default;
    transition: background-color 0.3s, cursor 0.3s; /* 添加过渡效果 */
    display: inline-block;
}
.ship-link:hover{
    color: #1677ff;
    cursor: pointer;
}
.hts-description-detail:hover{
    cursor: pointer;
}
.hts-description-detail{
    cursor: default;
}
</style>